import styled from 'styled-components';
import Link from '@material-ui/core/Link';
import AppleStore from 'assets/icons/AppleStore.svg';
import GooglePlay from 'assets/icons/GooglePlay.svg';

const StyledAppleStore = styled.div`
  background-image: url(${() => AppleStore});
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1rem;
  width: 120px;
  height: 38px;
  cursor: pointer;
`;

const StyledGooglePlay = styled.div`
  background-image: url(${() => GooglePlay});
  background-repeat: no-repeat;
  background-size: contain;
  margin-left: 1rem;
  margin-top: 1rem;
  width: 120px;
  height: 60px;
  cursor: pointer;
`;

const StyledWhereTo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 1rem;
  margin-bottom: 1rem;
  @media (max-width: 575px) {
    margin: 1.5rem;
  }
`;

const StyledAppStoreLinksFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const StyledAppStoreFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 2rem;
  @media (max-width: 575px) {
    margin-top: 2rem;
  }
`;

const StyledAppStoreText = styled.div`
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #FFFFFF;
`;

const StyledSearchContainer = styled.div`
  display: flex;
`;

const StyledQuickLinksContainer = styled.div`
  padding-top: 1rem;
  width: 100%;
  color: #FFFFFF;
  text-align: start;
  font-family: Montserrat;
  font-weight: 700;
  size: 16px;
  line-height: 24px;
  a {
    margin: 0 0.5rem;
  }
`;

const StyledLink = styled(Link)`
  color: #FFFFFF !important;
  text-decoration: underline !important;
  cursor: pointer;
`

const StyledFormControl = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export {
  StyledWhereTo,
  StyledSearchContainer,
  StyledQuickLinksContainer,
  StyledFormControl,
  StyledLink,
  StyledAppStoreFlex,
  StyledAppStoreLinksFlex,
  StyledAppStoreText,
  StyledAppleStore,
  StyledGooglePlay,
};
